import React from 'react';

import { Box } from '@material-ui/core';
import Handlebars from 'handlebars';
import moment from 'moment-timezone';

import {
  capitalizeText, convertMeterToMileString, convertSecondToHour, formatDateTime, lowerCase,
  removeDash, renderLocation, replaceDash, splitText, upperCase, when, whenAnd, whenOr
} from '../../utils/handlebars';
import { getDotColor } from '../../utils/events';
import { sanitizeHTML } from '../../utils/sanitize';
import styles from './styles';

const customFunctions = [
  {
    func: renderLocation,
    name: 'renderLocation'
  },
  {
    func: lowerCase,
    name: 'lowerCase'
  },
  {
    func: upperCase,
    name: 'upperCase'
  },
  {
    func: removeDash,
    name: 'removeDash'
  },
  {
    func: replaceDash,
    name: 'replaceDash'
  },
  {
    func: convertMeterToMileString,
    name: 'convertMeterToMileString'
  },
  {
    func: convertSecondToHour,
    name: 'convertSecondToHour'
  },
  {
    func: capitalizeText,
    name: 'capitalizeText'
  },
  {
    func: splitText,
    name: 'splitText'
  },
  {
    func: formatDateTime,
    name: 'formatDateTime'
  },
  {
    func: when,
    name: 'when'
  },
  {
    func: whenAnd,
    name: 'whenAnd'
  },
  {
    func: whenOr,
    name: 'whenOr'
  },
]

customFunctions.map(func => Handlebars.registerHelper(func.name, func.func));

function DecoratedEvent({eventMap, isWithoutSecond = false, canShowMapLink}) {

  return (
    <div style={styles.innerItems}>
      <div style={styles.line}></div>
      {Array.from(eventMap.values()).map(({ origin, converted, template }, idx) => {
        if (converted.date) {
          return <div style={styles.item} key={idx}>
            <Box display={'flex'}>
              <div style={{flex: 1, position: 'relative'}}>
                <div style={styles.lineDate}/>
              </div>
              <div style={{width: 200, textAlign: 'center'}}>
                <span style={styles.date}>
                  {converted.date}
                </span>
              </div>
              <div style={{flex: 1, position: 'relative'}}>
                <div style={styles.lineDate}/>
              </div>
            </Box>
          </div>
        } else {
          var compileContent = Handlebars.compile(template.content);
          const rendered = compileContent({...converted, ...origin, canShowMapLink});
          
          return <div style={styles.item} key={idx}>
            <div style={styles.inner} className='item'>
              <div style={{...styles.car, backgroundColor: getDotColor(template.color, origin) || '#ccc' }} />
              <Box display={'flex'} flex={1} justifyContent={'space-between'} fontSize={12} fontFamily={'AvenirNext'} color={'rgb(74,74,74)'} lineHeight={1.7}>
                <div style={styles.notes} dangerouslySetInnerHTML={{ __html: sanitizeHTML(rendered) }} data-testid="event-content" />
                {isWithoutSecond && origin.ts && <div style={styles.time}>{moment.tz(origin.ts, moment.tz.guess()).format('hh:mm A z')}</div>}
                {!isWithoutSecond && origin.ts && <div style={styles.time}>{moment.tz(origin.ts, moment.tz.guess()).format('hh:mm:ss A z')}</div>}
              </Box>
            </div>
          </div>
        }
      })}
    </div>
  )
}

export default DecoratedEvent